export const Constant = {
  DEFAULT_DURATION_IN_MS: 200,
  DEFAULT_DELAY_IN_MS: 0,

  MIN_SCALE: 1,
  MAX_SCALE: 1.2,

  MIN_ROTATION_Z: 0,
  MAX_ROTATION_Z: Math.PI / 6,

  DAMPING: 3,
  REST_SPEED_THRESHOLD: 3,
  STIFFNESS: 1000,
  VELOCITY: 5,
};
